import request from '@/utils/request'

export const sendPhoneAuthCode = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/auth/sendPhoneAuthCode',
    data
  });
};

export const login = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/auth/login',
    data
  });
};

// 社交帐户绑定手机号码
export const bindPhoneNum = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/auth/bindPhoneNum',
    data
  });
};

// 修改用户昵称
export const updateUserNickname = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/my/updateUserNickname',
    data: data,
  });
};

// 生成二维码(获取优惠)
export const generateQrcode = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/promotion/generateQrcode',
    data: data,
  });
};

// 生成二维码(获取优惠)-根据加密参数
export const generateQrcodeBySecret = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/promotion/generateQrcodeBySecret',
    data: data,
  });
};

// 查二维码详情
export const selectPromotionQrcodeDetail = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/promotion/selectPromotionQrcodeDetail',
    data: data,
  });
};

// 微信登录测试
export const weixinoauth2 = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/common/test',
    data: data,
  });
};

// 微信登录获取信息测试
export const weixinuserinfo = (params) => {
  return request({
    method: 'GET',
    url: 'https://api.weixin.qq.com/sns/userinfo',
    params,
  });
};

// 微信内h5跳app 或取微信jsapi_ticket等参数
export const getWxJsapiTicketParam = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/common/getWxJsapiTicketParam',
    data: data,
  });
};

// 查询-分享链接参数解密
export const selectSharingLinkParamUnsecret = (data) => {
  return request({
    method: 'POST',
    url: '/client/user/promotion/selectSharingLinkParamUnsecret',
    data: data,
  });
};